const { attendanceState } = require('./teacherPayrollLessons');
const { lessonStartInstant } = require('./lessonOccurrences');
const { isFinalizedAttendance } = require('./lessonAttendance');
const { hasAnyRole } = require('./rbac');

const fail = (statusCode, code) => Object.assign(new Error(code), { statusCode, code });
function cancellationMode({ auth, occurrence, register, reason, now }) {
  const note = typeof reason === 'string' ? reason.trim() : '';
  if (!note || note.length > 1000) throw fail(400, 'LESSON_CANCELLATION_REASON_REQUIRED');
  const details = (register && register.lessonDetails) || {};
  if (details.lessonStatus === 'cancelled' || details.attendanceStatus === 'cancelled') throw fail(409, 'LESSON_ALREADY_CANCELLED');
  if (isFinalizedAttendance(register)) throw fail(409, 'LESSON_ATTENDANCE_FINALIZED');
  if (attendanceState(occurrence, register, now) === 'missing') {
    if (!hasAnyRole(auth, ['ADMIN'])) throw fail(403, 'Forbidden');
    return 'retroactive';
  }
  const start = lessonStartInstant(occurrence.date, occurrence.startTime, occurrence.timeZone || 'Europe/Warsaw');
  if (start.getTime() <= new Date(now).getTime()) throw fail(409, 'LESSON_ALREADY_STARTED');
  if (!hasAnyRole(auth, ['ADMIN', 'OPERATOR'])) throw fail(403, 'Forbidden');
  return 'scheduled';
}
module.exports = { cancellationMode };
